import { render, staticRenderFns } from "./coze.vue?vue&type=template&id=981a52e6&scoped=true"
import script from "./coze.vue?vue&type=script&lang=js"
export * from "./coze.vue?vue&type=script&lang=js"
import style0 from "./coze.vue?vue&type=style&index=0&id=981a52e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981a52e6",
  null
  
)

export default component.exports